import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "antd";
import * as AppActions from "../../../../../store/actions/app";
import Button from "@mui/material/Button";
import { Close } from "@mui/icons-material";

const AiTargetError = () => {
  // CONST VALS
  const dispatch = useDispatch();

  // REDUX DATA
  const submissionError = useSelector((state) => state.AppReducer.submissionError);
  const user = useSelector((state) => state.UserReducer.profile);

  // HANDLERS
  const previewHandler = () => {
    dispatch(AppActions.setSubmissionError(null));
  };
  return (
    <Modal
      className="ai-target-error-modal"
      open={submissionError ? true : false}
      onCancel={previewHandler}
      width={600}
      footer={null}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Dear {user?.username},</h2>
      <p>
        You have run into an error which has been sent to Conceptor's development team. We
        will address this error shortly and reach out to you.
      </p>
      <p>
        If you have any further concerns or do not hear from us, please reach out to{" "}
        <a href="mailto:internal@conceptor.ai">internal@conceptor.ai</a>
      </p>
      <div className="action-box">
        <button className="submit" onClick={previewHandler}>
          Got it
        </button>
      </div>
    </Modal>
  );
};

export default AiTargetError;
